import Chip from '@/components/atoms/chip';
import { Fact, Location } from '@/types';

interface Props {
  fact: Fact;
  fullDocRow?: boolean;
  gotoDocReference: (docId: string, factId: string, pageNumber: number) => void;
}

const FactDocumentDetails = ({ fact, fullDocRow = true, gotoDocReference }: Props) => {
  const uploadDate = new Date(fact.createdDate);

  return (
    <>
      <div className="mb-1 px-2 font-semibold text-gray-800">Sources</div>

      <div>
        {fact.locations.map((factLocation: Location, index: number) => {
          const pageNumber = factLocation?.boundingBoxes?.length > 0 ? factLocation?.boundingBoxes?.[0]?.pageNumber : 1;
          const file = factLocation.doc?.file?.name;
          const documentType = factLocation.doc?.type;
          const documentDateText = factLocation.doc?.dateText;

          return (
            <div key={`${factLocation.docId}-${index}`} className="flex w-full flex-col gap-2 px-2">
              <div className="flex w-full items-baseline gap-2">
                <div
                  key={factLocation.docId}
                  className="cursor-pointer overflow-hidden text-ellipsis text-blue-500 hover:text-blue-600 hover:underline"
                  onClick={() => gotoDocReference(factLocation.docId, fact.id, pageNumber)}
                >
                  {file}
                </div>
                <Chip className={`bg-brandTertiary/10 text-brandTertiary ${!fullDocRow ? 'ml-auto' : ''}`}>
                  {documentType}
                </Chip>
                {fullDocRow && documentDateText ? (
                  <span className="text-xs text-gray-600">{documentDateText}</span>
                ) : null}
                {fullDocRow && (
                  <div className="ml-auto text-xs whitespace-nowrap text-gray-500 italic">
                    uploaded: {`${uploadDate.getDate()}/${uploadDate.getMonth() + 1}/${uploadDate.getFullYear()}`}
                  </div>
                )}
              </div>

              <div className="border-l-4 border-gray-200 pl-2 text-gray-500">
                {factLocation.sources &&
                  factLocation?.sources?.map((f, i) => {
                    return (
                      <div key={i} className="text-xs">
                        [Page{f.pages.includes(',') ? 's' : ''} {f.pages}]{' '}
                        {f.text && f.text.length > 900 ? f.text.slice(0, 900) + '...' : f.text}
                      </div>
                    );
                  })}
              </div>

              {index < fact.locations.length - 1 && (
                <div className="my-2 border border-x-0 border-t-0 border-dashed"></div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default FactDocumentDetails;
